import {useEffect, useState} from "react";
import {Col, Modal, Row} from "react-bootstrap";
import {regularTextStyles} from "../Style";
import Cookies from "js-cookie";
import '../stylesheet/directdebitterms.css'
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

function DirectDebitTerms(props) {
  //let url = 'http://localhost:8080/edge';
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [enableButton, setEnableButton] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');
  const {executeRecaptcha} = useGoogleReCaptcha();
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
      ? 'carAutosureEvent'
      : window.location.href.includes('quashed')
          ? 'carQuashedEvent'
          : window.location.href.includes('better')
              ? 'carBetterEvent'
              : window.location.href.includes('simplify')
                  ? 'carSimplifyEvent'
                  : '';

  const handleClose = () => {
    setEnableButton(false);
    props.setParentDeclarationPopupShow(false);
  };

  const handleCloseAndNext = () => {
    handleClose();
    props.proceedWithPayment();
  }

  const onChange = (value) => {
    setEnableButton(value);
    props.handleChangeValue('directDebitTermAccepted', value);
  }
  // useEffect(() => {
  //     let jwt = Cookies.get('jwt-token');
  //
  //     fetch(url + '/vero/document/directdebit/term', {
  //         method: "GET", mode: "cors",
  //         headers: new Headers({
  //              "Authorization": `Bearer ${jwt}`
  //         }),
  //     })
  //         .then((response) => {
  //             response.text().then((text) => {
  //                setHtmlContent(text);
  //             });
  //         })
  //         .catch((err) => console.error("Caught error: ", err));
  // })
  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Submit',
        'categoryDetails': 'Bank Transfer Terms and Conditions Consent',
        'status': 'Success',
        'virtualUrl': `${baseUrl}/vehicle/step5`,
        'pageTitle': 'Payment',
      });
    // Call the fetchTermContent function when the component mounts
    fetchTermContent();
  }, []);

  const fetchTermContent = async () => {
    try {
      let jwt = Cookies.get('jwt-token');

      const response = await fetch(`${url}/vero/document/directdebit/term`, {
        method: "GET",
        mode: "cors",
        headers: new Headers({
          "Authorization": `Bearer ${jwt}`
        }),
      });

      const text = await response.text();
      setHtmlContent(text);
    } catch (err) {
      console.error("Caught error: ", err);
    }
  };
  return (<span style={{fontSize: "10px"}}>
      <Modal
        show={props.parentDeclarationPopupShow}
        onHide={handleClose}

        backdrop="static"
        size="lg"
        keyboard={false}
      >


        <Modal.Body style={{background: 'white'}}>
          <div style={regularTextStyles}>
          <span className="popup-text">
           <div
             dangerouslySetInnerHTML={{__html: htmlContent}}
           />
              <p>
              <label>
            <input type="checkbox"
                   name="agreeCheckbox"
                   className="form-check-input"
                   checked={enableButton}
                   style={{
                     borderColor: '#555',
                     borderWidth: '2px',
                     borderStyle: 'solid',
                   }}
                   onChange={() => onChange(!enableButton)}/>&nbsp;&nbsp;
                <b for="agreeCheckbox" style={{cursor: 'pointer'}}>
                  I agree to the direct debit terms & conditions.</b>
              </label>
          </p>

          </span>
          <Row>
            <Col>
                 <p
                   style={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     alignItems: "center",
                     paddingTop: '32px'
                   }}>
              <button style={{
                color: '#1851A3',
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                background: 'white',
                border: '1px #1851A3 solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                wordWrap: 'break-word',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 6,
                width: "100%",
                maxWidth: "200px"
              }}
                      onClick={handleClose}
                      className="float-left">
                Close
              </button>
              <button  style={{
                color: 'white',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 6,
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                overflow: 'hidden',
                border: '1px white solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                width: "100%",
                maxWidth: "200px",
                background: enableButton ? '#1851A3' : '#B0C4DE',
                cursor: 'pointer',
              }}
                       onClick={handleCloseAndNext}
                       disabled={!enableButton} className="float-end">
                Next
              </button>
                 </p>
            </Col>
          </Row>
          </div>
        </Modal.Body>
      </Modal>
    </span>);
}

export default DirectDebitTerms;
